<!-- 顶部背景图+文字 -->
<template>
  <div
    class="twoNodeBg"
    :style="{backgroundImage: 'url(' + (image ? image : baseImg) + ')', backgroundSize:'cover'}"
  >
    <div class="bgColor">
      <!-- <img :src="image" alt srcset /> -->
      <div class="text">
        <div class="title1" v-show="content.length==0">{{title}}</div>
        <div class="title" v-show="content.length!=0">{{title}}</div>
        <div class="content" v-show="content.length">{{content}}</div>
        <el-button
          type="primary"
          v-show="bl"
          @click="rounLink(aLink?aLink:'issueTest')"
        >{{blName?blName:'立即咨询'}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    title: String,
    image: String,
    content: String,
    bl: Boolean,
    aLink: String,
    blName: String,
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    rounLink(i) {
      if (sessionStorage.getItem('codes')) {
        this.$router.push({
          name: i,
        })
      } else {
        this.$router.push({
          name: 'login',
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.twoNodeBg {
  height: 450px;
  margin-bottom: 10px;
  .bgColor {
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  .text {
    position: relative;
    width: 1100px;
    height: 100%;
    margin: 0 auto;
    .title1 {
      font-weight: 700;
      font-size: 48px;
      color: #fff;
      letter-spacing: 5px;
      margin-bottom: 10px;
      padding-top: 130px;
    }
    .title {
      font-weight: 700;
      font-size: 32px;
      color: #fff;
      margin-bottom: 10px;
      padding-top: 100px;
    }
    .content {
      font-size: 18px;
      color: #ffffff;
      line-height: 30px;
      width: 600px;
      text-indent: 2em;
    }
    .el-button {
      position: absolute;
      bottom: 50px;
    }
  }
}
</style>
